<template lang="pug">
el-container(v-if="filesInQueue.length > 0")
  el-header(height='20px')
    p.warning {{$t('Media conversions in progress')}}
      span &nbsp; &nbsp;
      el-checkbox(id="FileList-showWholeQueueButton" size="mini", type='text', v-model='showWholeQueue')
        p {{ $t('Show whole queue') }}
    hr.header
  .file-container
    .file-row(
        v-for="file in filesInConversion",
        :key="file.id",
        draggable,
      )
      .cell.progress
        el-progress(v-if='file.convertionProgress < 100', :percentage='parseInt(file.convertionProgress)', color='#0071ff')
        span {{ file.originalfilename }} - {{ $moment(file.createdAt).format('HH:mm:ss.SSS') }}
      .cell.mime-type
        span {{ file.originalMimeType }}
      .cell.mime-type
        span {{ humanFileSize(file.originalSize) }}
      .cell.operations(v-if="userIsAdmin")
        el-button(:id="'FileList-deleteFileButton' + file.id" size="mini", type='text', @click='deleteFile(file)')
          font-awesome-icon(icon="trash")
</template>

<script>
import Vue from 'vue'
import FileShortInfo from './ShortInfo'
import ListItemMixin from './../Medium/ListItem.mixin'
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [ListItemMixin, textUtils],
  props: ['side'],
  components: {
    FileShortInfo
  },
  created () {
    this.loadData()
  },
  watch: {
    filesInConversionLength: async function (newVal, oldVal) {
      if (newVal < oldVal) {
        this.$emit('file-Converted')
      }
    }
  },
  data () {
    return {
      errors: {
      },
      showWholeQueue: true
    }
  },
  methods: {
    loadData () {
      this.$store.dispatch('File/getData')
      // this.$store.dispatch('File/activateWsListener')
      this.$store.dispatch('File/filesWhereSeen')
    },
    reloadData () {
      this.loadData()
    },
    async deleteFile (file) {
      this.isSaving = true
      await Vue.axios
        .post(`file/destroyConversion`, { id: file.id })
        .then(response => {
          this.loadData()
        })
    }
  },
  computed: {
    filesInQueue () {
      return this.$store.state.File.file_list.filter(file => file.convertionProgress !== 100)
    },
    filesInConversion () {
      let files = this.filesInQueue
      if (!this.showWholeQueue) {
        files = files.filter(f => f.convertionProgress > 0)
      }
      return files.sort((a, b) => (a.createdAt > b.createdAt) ? 1 : ((b.createdAt > a.createdAt) ? -1 : 0))
    },
    filesInConversionLength () {
      return this.filesInConversion.length
    },
    // FIXME DRY
    userRoleNames () {
      return this.$store.state.User.user.Roles.map(role => role.name)
    },
    userIsAdmin () {
      return this.userRoleNames.includes('superadministrator') || this.userRoleNames.includes('administrator')
    },
    userIsSuperAdmin () {
      return this.userRoleNames.includes('superadministrator')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.file-container {
  color: $--color-text-regular;
  font-size: $--font-size-base;
  .file-row {
    padding: 5px;
    display: flex;
    border-bottom: $--border-light;
    align-items: center;
    justify-content: space-between;
    .progress {
      width:50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/File/List.vue